
export interface TokenData {
    accesstoken: string;
    refreshtoken: string;
    type?: string;
    expires_at?: Date;
}

export class UserData {
    isUserLoggedIn = false;
    clientId: string;
    tenantId: string;
    tenant: string;
    emailId: string;
    userId: string;
    userName: string;
    groupId: string;
    roleId: number;
    accessType: string;
    config = [];
    tenantLogo: string;
    devices = [];
    languages = [];
    metaInfo: any;
    sessionid: string;
    servicecenters: any[];
    selectedServiceCenter: number;
    creditdetails?: { balance: number, used: number, limit: number }
}

